import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Link, Paper, Typography } from '@mui/material';
import type React from 'react';

export interface NotificationProps {
  id: string;
  title: string;
  message: string;
  timestamp: Date | { toDate: () => Date };
  read: boolean;
  link?: string;
  dismissible?: boolean;
  onDelete: (id: string) => void;
}

const Notification: React.FC<NotificationProps> = ({
  id,
  title,
  message,
  timestamp,
  read,
  link,
  dismissible = true,
  onDelete,
}) => {
  const content = (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" data-testid="notification-title">
        {title}
      </Typography>
      <Typography variant="body2" sx={{ my: 1 }}>
        {message}
      </Typography>
      <Typography variant="caption" color="text.primary">
        {timestamp && (timestamp instanceof Date ? timestamp : timestamp.toDate()).toLocaleString()}
      </Typography>
    </Box>
  );

  return (
    <Paper
      elevation={2}
      data-testid={`notification-${id}`}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: read ? 'action.hover' : 'background.paper',
        borderLeft: 5,
        borderColor: read ? 'transparent' : 'primary.main',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {link ? (
        <Link href={link} underline="none" color="inherit" sx={{ flexGrow: 1 }}>
          {content}
        </Link>
      ) : (
        content
      )}
      {dismissible && (
        <IconButton onClick={() => onDelete(id)}>
          <DeleteIcon />
        </IconButton>
      )}
    </Paper>
  );
};

export default Notification;
